// extracted by mini-css-extract-plugin
export default {"root":"classes_root__gj8Ep","fill":"classes_fill__FX0Mg","stroke":"classes_stroke__BDhdP"};